// Show/hide toggle for password fields (.password-field, _account-page.scss): switches the input
// between password and text and reflects it in the button's aria-pressed and label.
export function initPasswordToggles() {
    document.querySelectorAll<HTMLButtonElement>('[data-password-toggle]').forEach(button => {
        const input = button.closest('.password-field')?.querySelector<HTMLInputElement>('input');
        if (!input) return;

        const showLabel = button.dataset.showLabel ?? 'Show password';
        const hideLabel = button.dataset.hideLabel ?? 'Hide password';

        button.addEventListener('click', () => {
            const show = input.type === 'password';

            input.type = show ? 'text' : 'password';
            button.setAttribute('aria-pressed', String(show));
            button.setAttribute('aria-label', show ? hideLabel : showLabel);
            input.focus();
        });
    });
}
